import { Route } from "react-router-dom";
import { FAQ } from "./faq";
import { getLocaleKeys } from "../i18n/locales";

export const FaqRoutes = (): JSX.Element[] => {
    const faqRoutes = getLocaleKeys().map(key => <Route path={`${key}/faq`} key={`${key}/faq`} element={<FAQ language={key} />} />);
    faqRoutes.push(<Route path={'faq'} key={'faq'} element={<FAQ />}/>);
    return faqRoutes;
}